import React from 'react';
import Style from './Stack.module.css';
import { Row, Col } from 'react-bootstrap';

export default function Stack() {
  return (
    <>
      <Row>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-reactjs'></i>
            <div>React-js</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-reactjs'></i>
            <div>React-Native</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-mongodb'></i>
            <div>Mongodb</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i className='icon-javascript'></i>
            <div>Javascript</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-html5'></i>
            <div>HTML</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-bootstrap'></i>
            <div>Bootstrapt</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i class='icon-css3'></i>
            <div>CSS</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <i className='fab fa-figma mb-4'></i>
            <div>Figma</div>
          </div>
        </Col>
        <Col sm={4}>
          <div className={Style.icon}>
            <div
              style={{
                fontWeight: '900',
                paddingTop: '10px',
                fontSize: '16px',
                color: 'rgb(17, 27, 27)',
              }}>
              EXPRESS
            </div>
            <div
              style={{
                fontWeight: '900',
                paddingTop: '20px',
                fontSize: '16px',
                color: 'rgb(17, 27, 27)',
              }}>
              FIREBASE
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
